<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row" :gutter="24">
        <a-col :span="24">
          <a-form-item :labelCol="titleCol" :wrapperCol="wrapperColTitle" label="标题">
            <a-input :read-only="params.isShow" placeholder="请输入标题" v-decorator="[
              'title',
              {initialValue:data.title,rules: [{ required: true, message: '请输入标题' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="类型">
            <a-select :disabled="this.params.isShow" :options="this.announcementTypeOptions" placeholder="请选择类型" v-decorator="[
              'announcementType',
              {initialValue:data.announcementType,rules: [{ required: true, message: '请选择类型' }]}]">
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item :labelCol="wrapperCol" :wrapperCol="labelCol" label="是否置顶">
            <a-checkbox @change="onStickyChange" :checked="data.isSticky" :disabled="this.params.isShow" v-decorator="[
              'isSticky',
              {initialValue:data.isSticky,rules: [{ required: false, message: '' }]}]"></a-checkbox>
          </a-form-item>
        </a-col>
        <a-col :span="8" v-if="this.showStickyDate">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="置顶期">
            <a-range-picker :disabled="this.params.isShow" :disabledDate="disabledDate" v-decorator="[
              'rangeTime',
              {initialValue:data.rangeTime,rules: [{ required: true, message: '请选择置顶期' }]}]" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="封面图">
            <upload-image :showUploadList="{showPreviewIcon: true, showRemoveIcon: !this.params.isShow }" :imageInit="this.data.imageUrl" @uploadChange="uploadChange" :fileListInit="fileList" :imageCount="1" @cancelFile="cancelFile">
            </upload-image>
                                  <span style="color:red">建议上传图片尺寸为320px*220px</span>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24" style="height:470px;">
        <a-col :span="8">
          <a-form-item :disabled="this.params.isShow" label="内容" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <div class="hp-editor">
              <script id="editor" ref="editor" type="text/plain"></script>
            </div>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
      <a-form-item label>
        <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
        <a-button style="margin-left:10px" @click="cancel">取消</a-button>
      </a-form-item>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
import { constants } from "zlib";
import { fail } from "assert";
const defaultData = {
  id: 0,
  title: "",
  announcementType: undefined,
  isSticky: false,
  stickyBeginTime: null,
  rangeTime: null,
  stickyEndTime: null
};
export default {
  name: "hp-manager-page-announcement-add",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      titleCol: {
        xs: { span: 24 },
        sm: { span: 2 }
      },
      wrapperColTitle: {
        xs: { span: 24 },
        sm: { span: 22 }
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      description: "",
      showStickyDate: false,
      announcementTypeOptions: [],
      listType: "text",
      fileList: []
    };
  },
  async mounted() {
    this.GetAnnouncementTypeOptions();
    if (this.params.id) {
      // this.data = Object.assign(this.params,defaultData)
      this.getdetailAnnouncement();
    } else {
      this.data = exzends(defaultData);
      this.initUeditor();
    }
  },
  destroyed() {
    if (this.editor) {
      this.editor.destroy();
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    uploadChange(fileList) {
      this.fileList = fileList;
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().startOf("day");
    },
    cancelFile(fileList) {
      this.fileList = fileList;
    },

    //UE 配置
    initUeditor() {
      this.editor = UE.getEditor("editor", {
        initialFrameWidth: 800,
        initialFrameHeight: 400
      }); // 初始化UE
      this.editor.addListener("ready", () => {
        this.editor.setContent(this.description); // 确保UE加载完成后，放入内容。
        if (this.params.isShow) {
          this.editor.setDisabled();
        }
      });
    },
    onStickyChange(e) {
      this.showStickyDate = e.target.checked;
    },
    async GetAnnouncementTypeOptions() {
      let dictionary = await api.GetDictionaryForSelect({ type: 2 });
      if (dictionary) {
        this.announcementTypeOptions = [];
        dictionary.forEach(a => {
          this.announcementTypeOptions.push({
            label: a.text,
            value: a.value,
            disabled: a.disabled
          });
        });
      }
    },
    async getdetailAnnouncement() {
      this.loading = true;
      let result = await api.GetAnnouncement({
        announcementId: this.params.id
      });

      if (result) {
        this.data = result;
        this.data.rangeTime = [
          new moment(this.data.stickyBeginTime),
          new moment(this.data.stickyEndTime)
        ];
      }
      if (this.data.coverImg && this.data.coverImg!="") {
        this.fileList.push({
          uid: Math.random().toString(),
          name: "1",
          status: "done",
          url: this.data.coverImg
        });
      }
      if(this.data.isSticky){
        this.showStickyDate=true;
      }

      this.data.announcementType += "";
      this.description = this.data.content;
      this.initUeditor();
      this.loading = false;
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        title: value.title,
        isSticky: value.isSticky,
        announcementType: value.announcementType,
        stickyBeginTime: this.showStickyDate
          ? value.rangeTime[0].startOf("day").valueOf()
          : null,
        stickyEndTime: this.showStickyDate
          ? value.rangeTime[1].startOf("day").valueOf()
          : null,
        content: "",
        coverImg: this.fileList.length > 0 ? this.fileList[0].url : ""
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });
      if (!valid.err) {
        let data;
        let requestData = this.dataToPostData(valid.values);
        requestData.content = this.editor.getContent();
        if (requestData.content == "") {
          this.loading = false;
          this.$message.error("请填写通知内容");
          return;
        }
        if (this.params.id > 0) {
          data = await api.CreateOrUpdateAnnouncement(requestData);
          if (data) {
            this.$message.success("修改成功");
            this.$emit("submit-success");
          }
        } else {
          data = await api.CreateOrUpdateAnnouncement(requestData);
          if (data) {
            this.$message.success("新增成功");
            this.$emit("submit-success");
          }
        }
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>
<style scoped>
.hp-editor {
  line-height: normal !important;
}
</style>


// WEBPACK FOOTER //
// src/router/Information/Announcement/Add.vue